import React from "react";

import RadioButton	from "../common/components/form/RadioButton";
import { PrimaryButton, SecondaryButton } from '../Ui'


function ContactForm({ subject, message, error, isSending, handleSubjectChange, handleMessageChange, handleSubmit, handleCancel }) {
	return (
		<div className="a-zoom" style={{margin: "0 auto", width: "600px", backgroundColor: "#FFF"}}>
			{/* Header */}
			<header className="modal__header">Nous contacter</header>
			{/* Content */}
			<div className="modal__content">
				<div>
					Sujet :
					<br />
					<RadioButton
						name="subject"
						value="expansion"
						checked={subject === "expansion"}
						onChange={handleSubjectChange}>

						Demander une extension
					</RadioButton>
					<br />
					<RadioButton
						name="subject"
						value="expansion.cylinders"
						checked={subject === "expansion.cylinders"}
						onChange={handleSubjectChange}>

						Recommander des cylindres
					</RadioButton>
					<br />
					<RadioButton
						name="subject"
						value="expansion.keys"
						checked={subject === "expansion.keys"}
						onChange={handleSubjectChange}>

						Recommander des clés
					</RadioButton>
				</div>
				<div>
					<textarea className="cc-input" rows="4" cols="50" placeholder="Décrivez votre demande"
						value={message}
						onChange={handleMessageChange} />
				</div>
				<div className="contact-form__error">{error}</div>
			</div>
			{/* Footer */}
			<footer className="modal__footer">
				<span className="mr-1">
					<SecondaryButton
						onClick={handleCancel}>

						Annuler
					</SecondaryButton>
				</span>
				<PrimaryButton
					loading={isSending}
					onClick={handleSubmit}>

					Envoyer la demande
				</PrimaryButton>
			</footer>
		</div>
	);
}

export default ContactForm;



// WEBPACK FOOTER //
// ./src/js/project-v2/ContactForm.js